module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero.850dbc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/job-description-generator/fullscreen-image_hero.png
// module id = bv1y
// module chunks = 0